import CardContainer from "../Containers/CardContainer";
import Heading from "../Headers/Heading";
import FormattedResponse from "../Response/FormattedResponse";

const UserResponseCard = ({ userResponse, className }) => {
  return (
    <CardContainer className="p-6">
      <Heading>আপনার উত্তর</Heading>
      <FormattedResponse response={userResponse} className={className} />
    </CardContainer>
  );
};

export default UserResponseCard;
